// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --progress-bar-bg: #e9e9e9;
  --progress-bar-width: 8px;
  --progress-bar-text-color: inherit;
  --progress-value-bg: var(--primary-color);

  display: block;
}

@media (prefers-reduced-motion: no-preference) {

:host {
    --progress-value-bg: repeating-linear-gradient(
      to right,
      var(--primary-color) 0%,
      var(--primary-color-20) 50%,
      var(--primary-color) 100%
    );
}
  }

:host(.is-success) {
  --progress-value-bg: var(--primary-color);
}

:host(.is-success) .d-icon {
    color: var(--color-success-05);
  }

:host(.is-stalled) {
  --progress-value-bg: var(--color-gray-03-transp);
  --progress-bar-text-color: var(--color-gray-03-transp);
}

:host(.is-aborted) {
  --progress-value-bg: var(--color-gray-05-transp);
}

:host(.is-failed) {
  --progress-value-bg: var(--color-error-06);
  --progress-bar-text-color: var(--color-error-06);
}

/*
 * Styling progress bars:
 * https://css-tricks.com/html5-progress-element/#aa-styling-progress-bars
 */

.d-progress-bar--progress-bar {
  appearance: none;
  background-color: var(--progress-bar-bg);
  border: none;
  display: flex;
  height: var(--progress-bar-width);
  margin: 8px 0;
  width: 100%;
}

/*
 * The value element has always full width and is clipped,
 * so that the background is not "compressed".
 */

.d-progress-bar--progress-value {
  background: var(--progress-value-bg) 0 100% / 200% auto;
  clip-path: inset(0 calc((1 - var(--progress-value, 0)) * 100%) 0 0);
  width: 100%;
}

@media (prefers-reduced-motion: no-preference) {

.d-progress-bar--progress-value {
    animation: progress-bar 3.2s linear infinite forwards;
}
  }

.d-progress-bar--labels-container {
  color: var(--progress-bar-text-color);
  display: flex;
  gap: 20px;
  justify-content: space-between;

  /* Added ellipsis support for these labels. */
}

.d-progress-bar--labels-container .d-progress-bar--label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

@keyframes progress-bar {
  from {
    background-position: 0 0;
  }

  to {
    background-position: -200% 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/progress-bar/progress-bar.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,kCAAkC;EAClC,yCAAyC;;EAEzC,cAAc;AAUhB;;AARE;;AARF;IASI;;;;;KAKC;AAEL;EADE;;AAGF;EACE,yCAAyC;AAK3C;;AAHE;IACE,8BAA8B;EAChC;;AAGF;EACE,gDAAgD;EAChD,sDAAsD;AACxD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;;;EAGE;;AACF;EACE,gBAAgB;EAChB,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,WAAW;AACb;;AAEA;;;EAGE;;AACF;EACE,uDAAuD;EACvD,mEAAmE;EACnE,WAAW;AAKb;;AAHE;;AALF;IAMI,qDAAqD;AAEzD;EADE;;AAGF;EACE,qCAAqC;EACrC,aAAa;EACb,SAAS;EACT,8BAA8B;;EAE9B,6CAA6C;AAO/C;;AANE;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;AAGF;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[":host {\n  --progress-bar-bg: #e9e9e9;\n  --progress-bar-width: 8px;\n  --progress-bar-text-color: inherit;\n  --progress-value-bg: var(--primary-color);\n\n  display: block;\n\n  @media (--animation-enabled) {\n    --progress-value-bg: repeating-linear-gradient(\n      to right,\n      var(--primary-color) 0%,\n      var(--primary-color-20) 50%,\n      var(--primary-color) 100%\n    );\n  }\n}\n\n:host(.is-success) {\n  --progress-value-bg: var(--primary-color);\n\n  & .d-icon {\n    color: var(--color-success-05);\n  }\n}\n\n:host(.is-stalled) {\n  --progress-value-bg: var(--color-gray-03-transp);\n  --progress-bar-text-color: var(--color-gray-03-transp);\n}\n\n:host(.is-aborted) {\n  --progress-value-bg: var(--color-gray-05-transp);\n}\n\n:host(.is-failed) {\n  --progress-value-bg: var(--color-error-06);\n  --progress-bar-text-color: var(--color-error-06);\n}\n\n/*\n * Styling progress bars:\n * https://css-tricks.com/html5-progress-element/#aa-styling-progress-bars\n */\n.d-progress-bar--progress-bar {\n  appearance: none;\n  background-color: var(--progress-bar-bg);\n  border: none;\n  display: flex;\n  height: var(--progress-bar-width);\n  margin: 8px 0;\n  width: 100%;\n}\n\n/*\n * The value element has always full width and is clipped,\n * so that the background is not \"compressed\".\n */\n.d-progress-bar--progress-value {\n  background: var(--progress-value-bg) 0 100% / 200% auto;\n  clip-path: inset(0 calc((1 - var(--progress-value, 0)) * 100%) 0 0);\n  width: 100%;\n\n  @media (--animation-enabled) {\n    animation: progress-bar 3.2s linear infinite forwards;\n  }\n}\n\n.d-progress-bar--labels-container {\n  color: var(--progress-bar-text-color);\n  display: flex;\n  gap: 20px;\n  justify-content: space-between;\n\n  /* Added ellipsis support for these labels. */\n  & .d-progress-bar--label {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n@keyframes progress-bar {\n  from {\n    background-position: 0 0;\n  }\n\n  to {\n    background-position: -200% 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
